import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';

export default class InactiveRecruits extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            reportData: [],
            yearData: [],
            fromWeekData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            selectedUnit: 0,
            selectedUnitName: '',
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getInactiveRecruits = this.getInactiveRecruits.bind(this);
        
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value
        })
        this.props.loaderOff();
    }

    async getInactiveRecruits() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/demonstrator/getInactiveRecruits?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200);
        let demRecs = [];
        let rec;
        result.data.map((perfRec) => {
            let telNo = "tel:" + perfRec.telephoneCell;
            rec = {
                unitName: perfRec.unitName,
                managerFirstNames: perfRec.managerFirstNames,
                managerSurname: perfRec.managerSurname,
                sfCurrentCode: perfRec.sfCurrentCode,
                firstNames: perfRec.firstNames,
                surname: perfRec.surname,
                telephoneCell: [<a href={telNo}>{perfRec.telephoneCell}</a>],
                startWeekId: perfRec.startWeekId,
                status: perfRec.statusCode1 + '' + perfRec.statusCode2,
                lastActiveWeekId: perfRec.lastActiveWeekId == -1 ? [<span style={{ color: "red" }}>Not Active</span>] : perfRec.lastActiveWeekId
            };
            demRecs.push(rec);
        });

        let tableData = {
            columns: [{
                label: 'Unit Name',
                field: 'unitName',
                sort: 'asc'
            },
            {
                label: 'Manager Name',
                field: 'managerFirstNames',
                sort: 'asc'
            },
            {
                label: 'Manager Surname',
                field: 'managerSurname',
                sort: 'asc'
            }, {
                label: 'Dem Code',
                field: 'sfCurrentCode',
                sort: 'asc'
            }, {
                label: 'Dem Name',
                field: 'firstNames',
                sort: 'asc'
            }, {
                label: 'Dem Surname',
                field: 'surname',
                sort: 'asc'
            }, {
                label: 'Tel.',
                field: 'telephoneCell',
                sort: 'asc'
            }, {
                label: 'Start Week',
                field: 'startWeekId',
                sort: 'asc'
            }, {
                label: 'Type',
                field: 'status',
                sort: 'asc'
            }, {
                label: 'Last Active',
                field: 'lastActiveWeekId',
                sort: 'asc'
            }],
            rows: demRecs
        }
        this.setState({
            reportData: tableData,
            tableHidden: false
        });
        this.props.loaderOff();
    }

    render() {
        let subHeaderText = "(Click Go to load inactive recruit report for selected weeks.)"
        return (
            <div>
                <Header headerText='Inactive Recruits'
                    subHeaderText={subHeaderText}
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBContainer>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Year..."
                                                options={this.state.yearData}
                                                selected="Filter"
                                                getValue={this.handleYearSelectChange}
                                                required
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="From Week..."
                                                options={this.state.fromWeekData}
                                                selected="Filter"
                                                getValue={this.handleFromSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="To Week..."
                                                options={this.state.toWeekData}
                                                selected="Filter"
                                                getValue={this.handleToSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn onClick={this.getInactiveRecruits}>Go</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>


                        </MDBRow>

                        <br />

                        <div hidden={this.state.tableHidden}>
                            <hr />
                            <MDBContainer>
                                <MDBRow>
                                    <div style={{ fontWeight: "bold" }}>Inactive Recruit Results for Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</div>
                                </MDBRow>


                            </MDBContainer>
                            <div style={{ paddingBottom: "15px" }}></div>
                            <MDBContainer>
                                <MDBDataTable
                                    responsive
                                    striped
                                    bordered
                                    hover
                                    data={this.state.reportData}
                                    paging={false}
                                    autoWidth
                                    searching={false}
                                />;
                            </MDBContainer>
                        </div>
                    </MDBCardBody>
                </MDBCard>
            </div>
        );
    }


}
